import { useQuery } from '@tanstack/react-query'
import {
  PayRateTimeseries,
  getPayRateTimeseries,
} from 'api/pulse/payRateTimeseries'
import { PulseFilters } from 'api/pulse'
import { getPayRateTimeseriesKey } from './keys'
import { PULSE_QUERY_OPTIONS } from './constants'

export function usePayRateTimeseries(query: PulseFilters) {
  return useQuery<PayRateTimeseries>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getPayRateTimeseriesKey(query),
    queryFn: ({ signal }) => getPayRateTimeseries(query, signal),
    enabled: !!query.companyIds?.length,
  })
}
